import { heFetch } from '../api/HeFetch';
import { handleUnauthorized } from './auth';

export const FETCH_HOME_FAVORITES = 'FETCH_HOME_FAVORITES';
export const ADD_HOME_FAVORITE = 'ADD_HOME_FAVORITE';
export const REMOVE_HOME_FAVORITE = 'REMOVE_HOME_FAVORITE';

export function getFavorites(homeFavorites) {
    return {
        type: FETCH_HOME_FAVORITES,
        homeFavorites
    };
}

export function addFavorite(homeId) {
    return {
        type: ADD_HOME_FAVORITE,
        homeFavorites: homeId
    };
}

export function removeFavorite(homeId) {
    return {
        type: REMOVE_HOME_FAVORITE,
        homeFavorites: homeId
    };
}

export function fetchHomeFavorites() {
    return (dispatch) => {
        return handleUnauthorized(dispatch, async () => {
            const response = await heFetch.get('/favorites/ids');
            const homeIds = Array.isArray(response) ? response : response?.data ?? [];
            dispatch(getFavorites(homeIds));
        });
    };
}
